// Company data
export const CompanyName = 'Phoenix Headdress';
export const CompanyPhoneNumber = '07846286385';
export const CompanyWhatsappNumber = '02031234567';
export const CompanyEmailAddress = 'phoenix@phoenixheaddress.com';
export const DirectorName = 'Phoenix';
export const LocationCity = 'London';
export const LocationCountry = 'United Kingdom';

// Address Constants
export const AddressLine1 = 'Luxury Nails Boutique';
export const AddressLine2 = '123 High Street';
export const AddressLine3 = 'Mayfair, London';
export const AddressLine4 = 'W1K 3QT, United Kingdom';
export const PostalCode = 'W1K 3QT';

export const CompanyTagLine = 'Handcrafted Power from the Studio';
export const MainTitle = 'Phoenix – Artist & Headdress Creator';
export const SubtitleMain = 'Where fantasy, fire, and feathers collide.';
export const SubtitleSecondary = `What can Phoenix craft for you?`;

export const KeywordsPages =
  'Phoenix, headdress artist, fantasy costume, handmade headdresses, custom headpieces, feather crowns, avant-garde fashion, wearable art, theatrical design, festival fashion, bespoke costume, studio artist, costume designer';

// Cookie data
export const NumberOfCookies = 0;
export const COOKIE_TIMER = 10000;
export const CookiePolicyName = 'CookiePolicy';

// Business URL
export const FULL_BUSINESS_URL = 'https://www.phoenixheaddress.com';
export const SHORT_BUSINESS_URL = 'phoenixheaddress.com';
export const DISPLAY_BUSINESS_URL = 'www.phoenixheaddress.com';

// Social Media URLs
export const FACEBOOK_URL = 'https://facebook.com/';
export const INSTAGRAM_URL = 'https://www.instagram.com/phoenixheaddress?utm_source=qr';
export const GOOGLE_URL = 'https://google.com/';
export const GITHUB_URL = 'https://github.com/';
export const APPLE_URL = 'https://apple.com/';
export const LINKEDIN_URL = 'https://apple.com/';
export const X_URL = 'https://x.com/';
export const TWITTER_URL = 'https://twitter.com/';

// Maps
export const GoogleMapsEmbedUrl = "https://www.google.com/maps/embed?pb=YOUR-EMBEDDED-MAP-URL";

// Bot Data
export const BotName = 'Jerry'